import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BaseLoadView from '~/components/Shared/BaseLoadView/BaseLoadView';
import { TableViewContextType } from '~/enums/TableViewType';
import { slices } from '~/redux/slices';

const GroupDocumentsLoadView = ({ onViewSelected }) => {
  const modal = useSelector(slices.documentGroup.selectors.selectModal);
  const dispatch = useDispatch();
  const hideModal = () => dispatch(slices.documentGroup.actions.setModal());
  const { modalType } = modal || {};

  return (
    <BaseLoadView
      context={TableViewContextType.GROUP}
      modalType={modalType}
      hideModal={hideModal}
      onViewSelected={onViewSelected}
    />
  );
};

export default GroupDocumentsLoadView;
